import { render } from "./Cart-notification.vue?vue&type=template&id=1ae06c78"
import script from "./Cart-notification.vue?vue&type=script&lang=js"
export * from "./Cart-notification.vue?vue&type=script&lang=js"

import "./Cart-notification.vue?vue&type=style&index=0&id=1ae06c78&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__